module.exports = "<div class=chart-container #chartContainer></div> ";